import React, { useState, useEffect } from "react";
import css from "./index.m.css";
import { Button, Modal, message } from "@cloud/atom-ui";
import VersionTable from "./component/versionList";
import history from "@src/utils/history";
import { queryString, getAppPathFromType, APP_TYPE } from "@src/utils/common";
import VersionOperation from "./versionOperation";
import SubmitPreAudit from "./submitPreAudit";
import {
  getVersionList,
  deleteVersionList,
  versionDetail,
  saveVersion,
  undoAudit,
  handleTenantInfo,
} from "./thunk";
import { contentList, clickVersionItem, isCreateVersion } from "./utils";
import { useNavigate } from "react-router-dom";
import { APP_WITHOUT_GUI } from "./constant";
import CommonHeader from "../../components/common-header";
import { useDispatch } from "redux-react-hook";
import * as actions from "@src/actions/index";

export default props => {
  const {
    match: {
      params: { type: paramsType }
    }
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [versionDisable, setVersionDisable] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const versionStatus = queryString("versionStatus") || "";
  const appId = queryString("id") || "";
  const [tableLoading, setTableLoading] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [publishModalVisible, setPublishModalVisible] = useState(false);
  const [updateContentList, setUpdateContentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mobileList, setMobileList] = useState([]);
  const [pcList, setPcList] = useState([]);
  const [versionParams, setVersionParams] = useState({});
  const [curVersionName, setCurVersionName] = useState("");

  const deleteColumn = () => {
    setDeleteStatus(true);
  };

  const deleteVersion = () => {
    deleteVersionList(appId, paramsType)
      .then(res => {
        if (res.status === 1) {
          getVersionTableList();
          setDeleteStatus(false);
        } else {
          message.warning(res.errMsg || "删除列表失败");
        }
      })
      .catch(error => {
        message.warning("删除列表失败");
      });
  };

  const clickCreateVersion = () => {
    history.push(
      `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}&versionStatus=create`,
      {
        state: {
          curVersionName: tableList?.[0]?.versionName || "",
          status: 1
        }
      }
    );
  };

  const getVersionTableList = () => {
    setTableLoading(true);
    getVersionList(appId, getAppPathFromType(paramsType))
      .then(res => {
        if (res.status === 1) {
          // isv应用全部被驳回后  可创建版本
          const isRejected = !!res?.data?.filter(
            item => item?.preReviewStatus && item?.preReviewStatus !== 3
          )?.length;
          if (paramsType === APP_TYPE.isv && !isRejected) {
            setVersionDisable(false);
          } else {
            setVersionDisable(isCreateVersion(res.data));
          }
          setTableList(res.data);
          setTableLoading(false);
        } else {
          setTableLoading(false);
          message.warning(res.errMsg);
        }
      })
      .catch(error => {
        console.log(error);
        setTableLoading(false);
        message.warning("获取列表失败");
      });
  };

  const getTenantInfo = () => {
    handleTenantInfo().then(res => {
      dispatch(actions.getTenantInfoAction(res?.data));
    });
  };

  useEffect(() => {
    if (!versionStatus) {
      getVersionTableList();
    }
    getTenantInfo();
  }, []);

  const getVersionItem = state => {
    setLoading(true);
    versionDetail(
      appId,
      versionStatus === "create" ? "" : state?.versionName,
      state?.status,
      paramsType
    )
      .then(res => {
        if (res.status === 1) {
          setLoading(false);
          const {
            versionName,
            mobileCapability,
            pcCapability,
            updateDescribe,
            versionUpdateInfo,
            mobileCapabilityList,
            pcCapabilityList
          } = res?.data;
          setVersionParams({
            ...versionParams,
            versionName: versionName,
            mobileCapability: mobileCapability || APP_WITHOUT_GUI,
            pcCapability: pcCapability || APP_WITHOUT_GUI,
            updateDescribe: updateDescribe
          });
          versionUpdateInfo &&
            setUpdateContentList([...contentList(versionUpdateInfo)]);
          setMobileList([...mobileCapabilityList]);
          setPcList([...pcCapabilityList]);
          versionStatus !== "create" && setCurVersionName(versionName);
        } else {
          message.warning(res.errMsg || "获取列表详情失败");
        }
      })
      .catch(error => {
        message.warning("获取列表详情失败");
      });
  };

  const changeVersionParam = valObj => {
    setVersionParams({ ...versionParams, ...valObj, appId: appId });
  };

  const savePublishVersion = () => {
    saveVersion({ ...versionParams, appId: appId }, paramsType)
      .then(res => {
        if (res.status === 1) {
          setPublishModalVisible(true);
        } else {
          message.warning(res.errMsg);
        }
      })
      .catch(error => {
        message.warning("保存版本失败");
      });
  };

  const withdrawalVersion = appId => {
    undoAudit(appId, getAppPathFromType(paramsType))
      .then(res => {
        if (res.status === 1) {
          navigate(
            `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`
          );
          getVersionTableList();
        } else {
          message.warning(res.errMsg || "撤销版本失败");
        }
      })
      .catch(error => {
        message.warning("撤销版本失败");
      });
  };
  if (
    versionStatus === "create" ||
    versionStatus === "update" ||
    versionStatus === "view" ||
    versionStatus === "underReview"
  ) {
    return (
      <VersionOperation
        changeVersionParam={changeVersionParam}
        updateContentList={updateContentList}
        getVersionItem={getVersionItem}
        versionParams={versionParams}
        savePublishVersion={savePublishVersion}
        setPublishModalVisible={setPublishModalVisible}
        publishModalVisible={publishModalVisible}
        withdrawalVersion={withdrawalVersion}
        loading={loading}
        getVersionTableList={getVersionTableList}
        mobileList={mobileList}
        pcList={pcList}
        paramsType={paramsType}
        curVersionName={curVersionName}
      />
    );
  }

  // 预审
  if (versionStatus === "preReview") {
    return <SubmitPreAudit />;
  }

  return (
    <div>
      <CommonHeader
        title="版本管理与发布"
        headerStyle={{ marginBottom: "19px" }}
      />
      <div className={css["version-main"]}>
        <p className={css["version-tip"]}>
          若企业自建应用需要供企业内其他用户使用，或三方企业应用需要上架Welink应用市场，都必须发布一个版本
        </p>
        <Button
          onClick={() => {
            clickCreateVersion();
          }}
          disabled={versionDisable}
          type="primary"
          className={css["version-btn"]}
        >
          创建版本
        </Button>

        {/* 版本列表 */}
        <VersionTable
          type={paramsType}
          tableLoading={tableLoading}
          deleteColumn={deleteColumn}
          tableSource={tableList}
          clickVersionItem={clickVersionItem}
          paramsType={paramsType}
        />
      </div>
      {deleteStatus && (
        <Modal
          title="提示"
          visible={deleteStatus}
          onOk={() => {
            deleteVersion();
          }}
          onCancel={() => {
            setDeleteStatus(false);
          }}
        >
          <p>确定删除该版本？</p>
        </Modal>
      )}
    </div>
  );
};
